<template>
  <div class="data container">
    <div class="box">
      <el-form
        :model="searchForm"
        ref="searchForm"
        class="search_form"
        :inline="true"
        size="small"
      >
        <el-form-item label="文件名称或文件类型:" prop="query">
          <el-input
            v-model="searchForm.query"
            placeholder="请输入文件名称或文件类型"
          ></el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="resetForm('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>

      <uploadFile @success="uploadSuccess" :fileType="[]">
        <el-button
          class="add_btn"
          size="small"
          type="primary"
          icon="el-icon-plus"
          >上传资料
        </el-button>
      </uploadFile>
      <el-table
        class="file_list"
        :data="fileList"
        height="calc(100% - 50px - 50px - 58px - 10px)"
      >
        <el-table-column prop="name" label="文件名称">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="上传时间"
          :formatter="formatter"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="type" label="类型" width="120" align="center">
        </el-table-column>
        <el-table-column prop="size" label="大小" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.size / 1024 / 1024).toFixed(2) }}M</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="是否开放"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-value="OPEN"
              inactive-value="CLOSE"
              :disabled="scope.row.system"
              @change="(e) => handleChange(e, scope.row.annexId)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small">
              <a :href="scope.row.url" :download="scope.row.name">下载</a>
            </el-button>
            <el-button
              v-show="!scope.row.system"
              @click.native.prevent="delRow(scope.row.annexId)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="foot_page">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :page-size="searchForm.limit"
          :current-page.sync="searchForm.page"
          :total="total"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  annexList,
  addAnnex,
  editAnnex,
  delAnnex,
} from "@/api/assistantMode/annex";
import uploadFile from "@/components/uploadFile";
import { formatDate } from "@/utils/index";
export default {
  name: "annexList",
  components: {
    uploadFile,
  },
  data() {
    return {
      searchForm: {
        page: 1,
        limit: 7,
        classChapterId: this.$route.query.classChapterId,
        query: "",
      },
      total: 0,
      fileList: [],
      params: {
        classChapterId: this.$route.query.classChapterId,
        fileId: "",
      },
      classChapterId: null,
    };
  },
  activated() {
    this.getAnnexList();
  },
  methods: {
    // 文件列表
    getAnnexList() {
      this.searchForm.classChapterId = this.$route.query.classChapterId;
      this.$loading.show();
      annexList(this.searchForm).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.fileList = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 上传成功
    uploadSuccess(file) {
      this.params.classChapterId = this.$route.query.classChapterId;
      this.params.fileId = file.fileId;
      addAnnex(this.params).then((res) => {
        if (res.code == 0) {
          this.$message.success("上传成功");
          this.getAnnexList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 格式化时间
    formatter(row) {
      return formatDate(row.createTime, "YYYY-MM-DD HH:mm:ss");
    },
    // 搜索
    onSubmit() {
      this.getAnnexList();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getAnnexList();
    },
    // 修改文件开放状态
    handleChange(status, annexId) {
      editAnnex({ status, annexId }).then((res) => {
        if (res.code == 0) {
          this.getAnnexList();
        } else {
          console.log(res.msg);
        }
      });
    },
    // 删除文件
    delRow(annexId) {
      this.$confirm("确定要删除该文件吗?", {
        type: "warning",
      })
        .then(() => {
          delAnnex(annexId).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getAnnexList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // handleDownload(url) {
    //   window.open(url, '_blank')
    // },
    // 翻页
    pageChange() {
      this.getAnnexList();
    },
  },
};
</script>

<style lang="less" scoped>
.data {
  height: 100%;

  .box {
    padding: 25px 35px;
    margin: 30px auto;
    height: calc(100% - 60px);
    background-color: rgb(255, 255, 255);

    .search_form {
      text-align: left;

      .el-form-item {
        margin-right: 40px;

        &.btns {
          float: right;
          margin-right: 0;
        }
      }
    }

    ::v-deep .el-upload,
    .add_btn {
      width: 100%;
    }

    ::v-deep .file_list {
      margin-top: 25px;
      // height: calc(100% - 60px - 50px - 58px - 25px);
      overflow: auto;
      .is-leaf {
        color: #333;
        background-color: #f5f5f5;
      }
    }

    ::v-deep .foot_page {
      margin-top: 20px;
      text-align: right;

      .el-pagination__total {
        float: left;
      }
    }
  }
}
</style>